if (!customElements.get('custom-announcement-bar-v2')) {
  customElements.define(
    'custom-announcement-bar-v2',
    class CustomAnnouncementBarV2 extends HTMLElement {
      connectedCallback() {
        if (this.dataset.timerEnabled !== 'true') return;
        this.initTimer();
      }

      disconnectedCallback() {
        this.stopTimer();
      }

      initTimer() {
        const endDate = this.dataset.endDate;
        const endHour = parseInt(this.dataset.endHour || '23', 10);

        if (!endDate || !/^\d{2}\/\d{2}\/\d{4}$/.test(endDate)) {
          console.error('Invalid date format. Expected DD/MM/YYYY');
          return;
        }

        const [day, month, year] = endDate.split('/').map(Number);
        this.endTime = new Date(year, month - 1, day, endHour, 0, 0);

        if (this.endTime <= new Date()) {
          this.hideBar();
          return;
        }

        this.timerElements = {
          hours: this.querySelector('[data-hours]'),
          minutes: this.querySelector('[data-minutes]'),
          seconds: this.querySelector('[data-seconds]'),
        };

        if (!this.timerElements.hours || !this.timerElements.minutes || !this.timerElements.seconds) {
          console.error('Timer elements not found');
          return;
        }

        this.updateTimer();
        this.intervalId = setInterval(() => this.updateTimer(), 1000);
      }

      updateTimer() {
        const diff = this.endTime - new Date();

        if (diff <= 0) {
          this.stopTimer();
          this.hideBar();
          return;
        }

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        this.timerElements.hours.textContent = String(hours).padStart(2, '0');
        this.timerElements.minutes.textContent = String(minutes).padStart(2, '0');
        this.timerElements.seconds.textContent = String(seconds).padStart(2, '0');
      }

      stopTimer() {
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }

      hideBar() {
        this.style.display = 'none';
      }
    },
  );
}
